import React, { useContext } from "react";
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as Actions from '../../../redux/actions/';
import { UserContext } from "../../../providers/user-provider";
import { auth } from "../../../firebase";
import { FaUser } from 'react-icons/fa';
import { useHistory } from "react-router-dom";

const UserInfo = ({setIsAuthenticating}) => {
  const user = useContext(UserContext);
	const userName = user && user.name;
	let history = useHistory();

	const handleSignOut = () => {
		setIsAuthenticating(false);
		auth.signOut();
		history.push(`/`);
	}

	const renderUserInfo = () => {
		if (user) {
			return (
				<div className="user-info">
					<button className="link" onClick={handleSignOut} title={`Logout ${userName || ''}`}><FaUser />Logout {userName}</button >
				</div>
			);
		}
		return null;
	}

  return renderUserInfo();
};

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = {
	setIsAuthenticating: Actions.setIsAuthenticating
};

export default compose(
	connect(mapStateToProps, mapDispatchToProps)
)(UserInfo);
